import { InsoleDesign } from "models/InsoleDesign";
import { toast } from 'react-hot-toast';
import { useDesignStore } from 'context/DesignContext';
import { getDefaultSaveSettings, SaveSettings, scheduleAutosave } from "components/Viewer3d/SaveManager"
import { Addition } from "models/Addition";

export const localDesignStack: Array<{ design: InsoleDesign, saveSettings: SaveSettings }> = [];
let undoSaveTimeout: NodeJS.Timeout | null = null;
let undoSaveSetting: SaveSettings = getDefaultSaveSettings();
let lastSaveSetting: SaveSettings = getDefaultSaveSettings();

export const pushDesignToStack = (design: InsoleDesign, saveSettings: SaveSettings = getDefaultSaveSettings()) => {
  localDesignStack.push({ design: InsoleDesign.cloneFrom(design), saveSettings: saveSettings });
  if (localDesignStack.length > 50) localDesignStack.shift();
};

export const resetStackWithDesign = (design: InsoleDesign) => {
  localDesignStack.length = 0;
  pushDesignToStack(design);
  undoSaveSetting = getDefaultSaveSettings();
};

export const undoLastAutosave = async () => {
  try {
    useDesignStore.setState({ undoLoaded: true });
    const designRestored = loadPreviousDesign();
    if (designRestored == null) return;
    const event = new CustomEvent('refreshAutomaticComponents');
    document.dispatchEvent(event);
    if (undoSaveTimeout) clearTimeout(undoSaveTimeout);
    if (localDesignStack.length == 0) return;
    setSaveSettings();
    undoSaveTimeout = setTimeout(async () => {
      await scheduleAutosave(`Undo`, undoSaveSetting);
      undoSaveSetting = getDefaultSaveSettings();
    }, 3000);
  }
  catch (error) {
    console.error('Error during undo:', error);
  }
};


const setSaveSettings = () => {
  // if (latestAction == null || latestAction == ActionType.others) return;
  if (lastSaveSetting.newAddition || lastSaveSetting.removeAddition) {
    undoSaveSetting.replaceAdditons = true;
  }
  if (lastSaveSetting.updateAddition) {
    undoSaveSetting.updateAddition = true;
  }
  if (lastSaveSetting.updateInsoleMesh) {
    undoSaveSetting.updateInsoleMesh = true;
  }
  if (lastSaveSetting.updateDesignInfo || lastSaveSetting.updateDesignCategory) {
    undoSaveSetting.updateDesignCategory = true;
    undoSaveSetting.updateInsoleMesh = true;
    undoSaveSetting.updateAddition = true;
  }
  undoSaveSetting.updateAutoProperties = true;
  undoSaveSetting.now = true;
  undoSaveSetting.isUndo = true;
}

export const loadPreviousDesign = async () => {
  if (localDesignStack.length <= 1) {
    toast.error('Nothing to undo.', { duration: 10000 });
    return null;
  }
  try {
    let designRestored;
    designRestored = localDesignStack[localDesignStack.length - 2].design;
    lastSaveSetting = localDesignStack[localDesignStack.length - 1].saveSettings;
    if (lastSaveSetting.updateAddition) {
      const currentDesign = localDesignStack[localDesignStack.length - 1].design;
      designRestored.insoles.forEach((insole, index) => {
        insole.additions.forEach((addition: Addition, adindex) => {
          addition.isUpdated = currentDesign.insoles[index].additions[adindex]?.isUpdated || false;
          if(addition.designAdditionId === 0){
            addition.designAdditionId = currentDesign.insoles[index].additions[adindex]?.designAdditionId;
          }
        });
      });
    }
    localDesignStack.pop();

    if (!designRestored) {
      toast.error('Failed to restore design.', { duration: 10000 });
      return;
    }
    useDesignStore.getState().setDesign(InsoleDesign.cloneFrom(designRestored));
    useDesignStore.setState({ designLoaded: true });
    return designRestored;
  } catch (error) {
    console.error('Error during undo:', error);
    toast.error('Failed to undo changes.', { duration: 10000 });
  }
}

